import { useTranslation } from 'react-i18next';
import { themeOptions } from './themeOptions';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Domain/components/Shared/Select/Select';
import { ThemeEnum } from '@/Domain/enum/Theme.enum';
import { useThemeStore } from '@/Domain/store/theme.store';

export const ThemeSelectDropdown = () => {
  const { t } = useTranslation('sidebar_menu');
  const theme = useThemeStore((state) => state.theme);
  const setTheme = useThemeStore((state) => state.setTheme);

  return (
    <Select value={theme} onValueChange={(value) => setTheme(value as ThemeEnum)}>
      <SelectTrigger className="min-w-[120px] h-[39px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {themeOptions.map(({ icon: Icon, value, labelKey }) => (
          <SelectItem key={value} value={value}>
            <div className="flex items-center gap-2">
              <Icon className="size-4" />
              <span>{t(labelKey)}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
